import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';

import BlankColumnContent from '../../../../../../../src/components/common/blank-column-content';
import { H4 } from '../../../../../../../src/components/common/text';
import Text from '@dbk/ui-text';
import {
  Currency,
  ChangeIndicatedPercent,
  ChangeIndicatedNumber,
} from '../../../../../../../src/components/common/number';
import { NO_DATA } from '../../../../../../../src/constants';
import styles from './chart-header.styles';
import SimpleDate from '../../../../../../../src/components/common/date';
import formatPriceForAsset from '../../../../../../../src/utils/asset-currency-roundoff';

class ChartHeader extends PureComponent {
  static propTypes = {
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    value: PropTypes.number,
    valueUnit: PropTypes.string,
    testID: PropTypes.string,
    valueLabel: PropTypes.string,
    dayChangeLabel: PropTypes.string,
  };

  static defaultProps = {
    testID: 'header',
    valueLabel: 'Security Price',
    dayChangeLabel: 'Price Change',
    priceDateLabel: 'Price Date'
  };

  
renderValue() {
    const { value, valueUnit, valueLabel, messages} = this.props;
    const fractions = {maximumFractionDigits: formatPriceForAsset(value).fractionalCount, minimumFractionDigits: formatPriceForAsset(value).fractionalCount};
    let valueText = messages['app.common.portfolio.fxRate'];
    if(valueLabel == valueText) {
      return(
        <div aria-label={value != null ? value : messages['app.common.nullValue']}>
          <Text >{value != null ? value : NO_DATA}</Text>
        </div>
      );
    }
    return (
      <Currency
        renderProps={{
          style: styles.itemValue,
          size: 'small',
          testID: 'value',
        }}
        value={value != null ? +formatPriceForAsset(value).displayedPrice: NO_DATA}
        currency={valueUnit}
        {...fractions}
      />
    );
  }

  renderDayChangeValue() {
    const { dayChange, dayChangePercentage } = this.props;

    if (dayChange == null || dayChangePercentage == null) {
      return <BlankColumnContent />;
    }

    return (
      <H4 style={styles.itemValue} testID="value">
        <ChangeIndicatedNumber
          value={dayChange}
          withPlusSign
        />
        &nbsp;
        <ChangeIndicatedPercent value={dayChangePercentage} withPlusSign>
          {
            (text, props) =>
              <Text {...props}>
                ({ text })
              </Text>
          }
        </ChangeIndicatedPercent>
      </H4>
    );
  }
  // JIRA #2975, Remove the Price change
  render() {
    const {
      valueLabel,
      dayChangeLabel,
      testID,
      priceDateLabel,
      priceDateValue,
      assetCategory,
      assetGroupId,
      assetShortDesc,
      messages
    } = this.props;

    if(assetShortDesc == 'cash' || assetShortDesc == 'mmDeposites' || assetShortDesc == 'credit') {
      return (<View></View>);
    }

    return (
      // <View style={styles.root} testID={testID} tabIndex={0} accessible={true}>
      //   <View style={styles.itemLeft} testID="balance-or-price" >
      //     <Text aria-label="MarketPrice" style={styles.itemLabel} testID="label">{messages['app.common.portfolio.alter.mktPrice']}</Text>
      //     <Text aria-label="PriceDate" style={[styles.itemLabel, styles.marginValue]} testID="label">{messages['app.portfolio.assetDetails.priceDate']}</Text>
      //   </View>

      //     <View style={styles.itemRight} testID="balance-or-price">
      //       {this.renderValue()}
      //         <View style={styles.marginValue}>
      //           <SimpleDate value={priceDateValue}/>
      //         </View>
      //     </View>
        <View>
        <View style={styles.root} testID="balance-or-price" accessible={true}>
        <View style={styles.itemLeft} testID="balance-or-price" >
        <Text secondary testID="label">{messages['app.common.portfolio.alter.mktPrice']}</Text>
        </View>
        <View style={styles.itemRight} secondary testID="isin-or-purchase">
        {this.renderValue()}
        </View>
        </View>

        <View style={styles.root2} testID="balance-or-price" accessible={true}>
        <View style={styles.itemLeft} testID="balance-or-price" >
        <Text secondary testID="label">{messages['app.portfolio.assetDetails.priceDate']}</Text>
        </View>
        <View style={styles.itemRight} secondary testID="isin-or-purchase">
                <SimpleDate value={priceDateValue} renderProps={{ size:"normal", type:'primary' }}/>
          </View>
          </View>
          </View>




        
     
    );
  }
}

export default ChartHeader;
